/** @jsx jsx */
import { Colors } from '@zapier/theme';
import { jsx, Interpolation } from '@emotion/core';
import { navLinkBaseCss } from '@zapier/product-dev-platform/src/constants';
import { HeaderNavLink } from '@zapier/product-dev-platform/src/types';

const mainNavLinkCss = ({
  isActive,
}: {
  isActive: boolean;
}): Interpolation => ({
  color: Colors.batmobile,
  textDecoration: 'none',
  position: 'relative',
  whiteSpace: 'nowrap',
  '@media (min-width: 1079px)': {
    ...navLinkBaseCss,
    ...(isActive
      ? {
          ...navLinkBaseCss['&:hover'],
          ':before': {
            content: "''",
            position: 'absolute',
            left: 0,
            bottom: -6,
            width: '100%',
            height: 2,
            backgroundColor: Colors.white,
          },
        }
      : {}),
  },
});

const exitIconCss: Interpolation = {
  display: 'inline-block',
  padding: '0 1ch',
  position: 'relative',
  top: '-0.25em',
  ':before': {
    content: '""',
    display: 'inline-block',
    width: 1,
    height: 1,
    border: `solid 5px transparent`,
    borderBottomColor: Colors.lava,
    verticalAlign: 'top',
    transform: 'rotate(45deg)',
  },
};

const NavLink: React.FC<HeaderNavLink> = ({
  href,
  label,
  isActive = false,
  isExit,
}) => (
  <a
    css={mainNavLinkCss({
      isActive,
    })}
    href={href}
  >
    {label}
    {isExit && <span css={exitIconCss} />}
  </a>
);

export default NavLink;
